/* CHEMS CRO: open the cart drawer only after an intentional add-to-cart action. */
(function () {
  var userAdding = false;
  var opening = false;
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (form && form.matches('form[action*="/cart/add"]')) userAdding = true;
  }, true);
  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-add-to-cart], .btn--add-to-cart, button[name="add"]')) userAdding = true;
  }, true);
  document.addEventListener('theme:cart:change', function (event) {
    if (!userAdding || opening || !event.detail || !event.detail.cart) return;
    userAdding = false;
    opening = true;
    window.setTimeout(function () {
      var noticeClose = document.querySelector('[data-product-add-popup] [data-close]');
      if (noticeClose) noticeClose.click();
      var cartToggle = document.querySelector('[data-drawer-toggle="drawer-cart"]');
      if (cartToggle) cartToggle.click();
      window.setTimeout(function () { opening = false; }, 250);
    }, 120);
  });
})();